// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AuthenticationController = function ($scope, $routeParams, $rootScope, $location, $http, $q, UserSettings, Features, PublicSettings, Permissions, LegalEntity, LoginDataCleanUp) {
    $scope.username = "";
    $scope.password = "";
    $scope.accessToken = "";
    $scope.refreshToken = "";
    $scope.specialLoginKey = $routeParams.specialLoginKey || "";
        
    if ($rootScope.accessToken) {
        $location.path($rootScope.defaultLocation());
        return;
    }

    if ($routeParams.language) {
        $scope.setLang($routeParams.language);
    } else {
        $scope.setLang($rootScope.defaultLanguage);
    }

    $scope.externalLogin = function () {
            $http({
                method: "POST",
                url: baseUrl + "externallogin/token",
                data: $location.search(),
                headers: {"Content-Type": "application/x-www-form-urlencoded"},
                transformRequest: transform,
                cache: false
            }).then(
                function (response) {
                    $scope.username = response.data["email"];
                    authorize(response)
                });
            $scope.password = null;
    }
    
    $scope.login = function () {
        $http({
            method: "POST",
            url: baseUrl + "oauth/token",
            data: { "username": $scope.username, "password": $scope.password, "client_id": "51014335eb596a0e149f2b36", "grant_type": "password", "special_login_key": $scope.specialLoginKey },
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            transformRequest: transform,
            cache: false
        }).then(
            function (response) {
                authorize(response)
            }
        );
        $scope.password = null;
    };

    function authorize(response) {
        
        LoginDataCleanUp.clean();

        var data = response.data;
        $scope.password = null;
        if (data["access_token"]) {
            $rootScope.accessToken = data["access_token"];
            $rootScope.refreshToken = data["refresh_token"];
            $rootScope.username = $scope.username;
            $http.defaults.headers.common["Authorization"] = "Bearer " + data["access_token"];
            localStorage.setItem('username', $rootScope.username);
            localStorage.setItem('access_token', $rootScope.accessToken);
            localStorage.setItem('refresh_token', $rootScope.refreshToken);
            localStorage.setItem('external_user', data["external_user"]);

            UserSettings.get(function (data) {
                localStorage.setItem("culture", data.Culture);
                localStorage.setItem("first_name", data.FirstName);
                localStorage.setItem("last_name", data.LastName);
                localStorage.setItem("email", data.Email);
                $scope.setLang(data.Culture);
            });

            $q.all([
                Features.reload(),
                LegalEntity.reload(),
                Permissions.reload(),
            ]).then(function() {
                $location.url($rootScope.defaultLocation());
            });
        }

        if (data["redirect"]) {
            $location.path(data["redirect"].replace("#", ""));
        }
    }
}
AuthenticationController.$inject = ['$scope', '$routeParams', '$rootScope', '$location', '$http', '$q', 'UserSettings', 'Features', 'PublicSettings', 'Permissions', 'LegalEntity', 'LoginDataCleanUp'];
